/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

/**
 * NoFeePeriods.jsx
 * Created by michael bray on 3/21/18.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { formatDateShort } from 'ui-activitypass/src/utils/upsell_utils';
import { isValidDateFormat, parseDate } from 'ui-activitypass/src/utils/date_time_utils';
import { NoFeeDaysProps } from '../../props';

function NoFeePeriods({ noFeePeriods = [], siteName }) {
    if (!noFeePeriods) return null;
    const sortedPeriods = noFeePeriods.sort((a, b) =>
        parseDate(a.date).compare(parseDate(b.date))
    );
    return noFeePeriods && noFeePeriods.length ? (
        <section className="rec-order-detail-need-help">
            <h4 className="activitypass-section-heading h6">Fee Free Days</h4>
            <div className="pp-activitypasses-fees">
                <p>Fees are waived at {siteName} on the following days:</p>
                <ul className="pp-activitypasses-fee-list">
                    {sortedPeriods.map(({ date, end, name }) => (
                        <li className="pp-activitypasses-fee-listitem" key={name}>
                            {formatDateShort(parseDate(date))}
                            {isValidDateFormat(end)
                                ? ` - ${formatDateShort(parseDate(end))}`
                                : ''}
                            : {name}
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    ) : null;
}

NoFeePeriods.propTypes = {
    noFeePeriods: NoFeeDaysProps,
    siteName: PropTypes.string,
};

export default NoFeePeriods;

// cspell:ignore activitypass, activitypasses, listitem
